export default __webpack_public_path__ + "static/media/ic_developer_board.811e4f17.svg";